import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { capitalise } from 'src/utils/capitalise-first-letter';
import { parseCountryIso } from 'src/utils/parse-third-party-country-code';
import { parseThirdPartyDOB } from 'src/utils/parse-third-party-dob';
import { parseThirdPartyUniversity } from 'src/utils/parse-third-party-university';

export const useUrlParams = () => {
    const [searchParams] = useSearchParams();
    const academicYear = searchParams.get('academicYear') || '';
    const roomCode = searchParams.get('roomCode') || '';
    const agentCode = searchParams.get('agentCode') || searchParams.get('agentcode') || null;
    const agentStudentId = searchParams.get('agentStudentId') || null;
    const firstName = capitalise(searchParams.get('firstName') || '');
    const lastName = capitalise(searchParams.get('lastName') || '');
    const preferredName = capitalise(searchParams.get('preferredName') || '');
    const email = searchParams.get('email') || '';
    const phone = searchParams.get('phone') || '';
    const callingCode = searchParams.get('callingCode') || '';
    const address1 = searchParams.get('address1') || '';
    const address2 = searchParams.get('address2') || '';
    const city = searchParams.get('city') || '';
    const postCode = searchParams.get('postCode') || '';
    const countryIso = searchParams.get('country') || '';
    const country = parseCountryIso(countryIso) || '';
    const dob = searchParams.get('dob');
    const parsedDob = parseThirdPartyDOB(dob || undefined);
    const university = searchParams.get('university') || '';
    const parsedUniversity = parseThirdPartyUniversity(university);

    return useMemo(
        () => ({
            academicYear,
            roomCode,
            agentCode,
            agentStudentId,
            firstName,
            lastName,
            preferredName,
            email,
            phone,
            callingCode,
            address1,
            address2,
            city,
            postCode,
            country,
            dob,
            parsedDob,
            university,
            parsedUniversity,
        }),
        [searchParams]
    );
};
